export * from './campaign.service';
import { CampaignService } from './campaign.service';
export * from './enrolCampaign.service';
import { EnrolCampaignService } from './enrolCampaign.service';
export * from './questionOption.service';
import { QuestionOptionService } from './questionOption.service';
export * from './questions.service';
import { QuestionsService } from './questions.service';
export * from './quizCampaign.service';
import { QuizCampaignService } from './quizCampaign.service';
export * from './quizUsers.service';
import { QuizUsersService } from './quizUsers.service';
export const APIS = [CampaignService, EnrolCampaignService, QuestionOptionService, QuestionsService, QuizCampaignService, QuizUsersService];
